module.exports = __webpack_public_path__ + "fonts/TTNormsPro-ExtraBoldItalic.72e89e5f.eot";